import * as React from "react"
import PropTypes from "prop-types"
import "./RequestFaveButton.scss"

// api
import { usePostFavoriteRequest } from "api/hooks/requests/requestFavoritesApis"

// context
import useAppState from "context/hooks/useAppState"

const RequestFaveButton = ({ request }) => {
  const postRequestFavorite = usePostFavoriteRequest(request?.id)
  const [isLoading, setIsLoading] = React.useState()
  const { emitRequestFaveUpdated } = useAppState()

  return (
    <i
      className={`fas fa-heart request-fave-button${request?.is_favorite ? " is-favorite" : ""}${
        isLoading ? " is-loading" : ""
      }`}
      onClick={() => {
        setIsLoading(true)
        postRequestFavorite(
          {},
          {
            onSuccess: () => {
              emitRequestFaveUpdated()
              setIsLoading(false)
            },
          }
        )
      }}
    />
  )
}

RequestFaveButton.propTypes = {
  request: PropTypes.shape({
    is_favorite: PropTypes.bool.isRequired,
  }),
}

export default RequestFaveButton
